import React from "react";
import backImage from "../../../../src/Assets/backImg3.png";
import { useLocation } from "react-router-dom";

const Temp1 = ({
  logo,
  brand_logo,
  headingText,
  subheadingText,
  businessTypes2,
  businessImage2,
  ctaHeading,
  ctaText,
  styles,
  SquareUserRound,
  rightFileInputRef,
}) => {
  const location = useLocation();

  // Function to determine if the background color is light
  const isLightColor = (hexColor) => {
    // Convert hex to RGB
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 200;
  };

  // Determine text color based on background color
  const textColor = isLightColor(styles.backgroundColor)
    ? "#000000"
    : "#FFFFFF";

  const handleClick = () => {
    if (location.pathname !== "/sucees_page") {
      rightFileInputRef.current.click();
    }
  };

  return (
    <div className="col-lg-4 HiddenClss step_8_show">
      <div className="preview-panel">
        <div
          className="mobile-frame mobile-frame2 custum_width_mobile"
          style={{
            backgroundImage: `url(${backImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
            position: "relative",
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
          }}
        >
          <div
            className="mobile-content"
            style={{ backgroundColor: "transparent" }}
          >
            {/* Logo Preview */}
            <div className="logo-preview" onClick={handleClick}>
              <input
                type="file"
                ref={rightFileInputRef}
                accept="image/*"
                style={{ display: "none" }}
              />
              {logo ? (
                <img
                  src={logo || brand_logo}
                  alt="Brand Logo"
                  className="preview-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = brand_logo;
                  }}
                />
              ) : (
                <div className="logo-placeholder">
                  <img
                    src={brand_logo}
                    className="brand_logo"
                    alt="brand_logo"
                  />
                </div>
              )}
            </div>

            {/* Heading & Subheading */}
            <div className="preview-heading">{headingText}</div>
            <div className="preview-subheading">{subheadingText}</div>

            {/* Social Icons */}
            <div className="social-icons">
              {businessTypes2.map((item, index) =>
                index < 4 ? (
                  <img
                    key={index}
                    src={businessImage2 + item.review_logo}
                    alt={item.review_name}
                    title={item.review_name}
                  />
                ) : null
              )}
            </div>

            {/* CTA Section */}
            <div className="preview-cta-section">
              <div
                className="preview-cta-heading"
                style={{ color: "var(--black)" }}
              >
                {ctaHeading}
              </div>
              <button
                className="preview-cta-button"
                style={{
                  backgroundColor: styles.backgroundColor,
                  color: textColor,
                }}
              >
                <SquareUserRound stroke={textColor} className="cta_icnn" />

                {ctaText}
              </button>
            </div>

            <div className="preview-footer">
              Powered by Your <span>Wowreviews</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Temp1;
